export const ROW_CLICK_IGNORE_SELECTOR =
	'button, a[href], .MuiLink-root, .has-link, .MuiCheckbox-root, input, [role="button"]';

export const isModifiedClick = (event) => {
	if (!event) return false;
	return (
		event.button === 1 ||
		Boolean(event.metaKey) ||
		Boolean(event.ctrlKey) ||
		Boolean(event.shiftKey) ||
		Boolean(event.altKey)
	);
};

export const isIgnoredRowClickTarget = (event) =>
	Boolean(event?.target?.closest?.(ROW_CLICK_IGNORE_SELECTOR));

export const handlePlainClick = (event, onPlainClick) => {
	if (!event || isModifiedClick(event)) return;
	event.stopPropagation();
	event.preventDefault();
	onPlainClick?.(event);
};

const joinPath = (fromPathname, relativePath) => {
	const fromSegments = fromPathname.replace(/\/+$/, '').split('/');
	relativePath.split('/').forEach((segment) => {
		if (segment && segment !== '.') {
			fromSegments.push(segment);
		}
	});
	return fromSegments.length > 1 ? fromSegments.join('/') : '/';
};

export const resolveAppHref = (to, fromPathname = '/') => {
	if (!to) return '';
	if (typeof to !== 'string') {
		const pathname = to.pathname ?? fromPathname;
		const search = to.search ?? '';
		const hash = to.hash ?? '';
		return `${pathname}${search}${hash}`;
	}
	if (/^(https?:|mailto:|tel:)/i.test(to)) {
		return to;
	}
	if (to.startsWith('?') || to.startsWith('#')) {
		return `${fromPathname}${to}`;
	}
	if (to.startsWith('/')) {
		return to;
	}
	return joinPath(fromPathname, to);
};

export const openInNewTab = (href) => {
	if (!href) return;
	window.open(href, '_blank', 'noopener,noreferrer');
};

export const getObjectTabPath = (pathname, recordId, tabValue = '') => {
	const segments = (pathname ?? '').split('/').filter(Boolean);
	const recordIndex = segments.findIndex((segment) => String(segment) === String(recordId));
	const baseSegments = recordIndex >= 0 ? segments.slice(0, recordIndex + 1) : segments;
	const base = `/${baseSegments.join('/')}`;
	return tabValue ? `${base}/${tabValue}` : base;
};

export const getSectionTabPath = (pathname, tabValue = '') => {
	const section = (pathname ?? '').split('/').filter(Boolean)[0];
	if (!section) {
		return tabValue ? `/${tabValue}` : '/';
	}
	return tabValue ? `/${section}/${tabValue}` : `/${section}`;
};
